// ページ先頭に移動
export const moveToPageTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
};
